import { render, staticRenderFns } from "./OrderConfig.vue?vue&type=template&id=4043d20c&scoped=true"
import script from "./OrderConfig.vue?vue&type=script&lang=js"
export * from "./OrderConfig.vue?vue&type=script&lang=js"
import style0 from "./OrderConfig.vue?vue&type=style&index=0&id=4043d20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4043d20c",
  null
  
)

export default component.exports